import { Component, Inject, OnInit } from '@angular/core';
import { CatalogsUserForm, ReportTexts, BusinessActivities } from 'src/models/catalogs';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/services/db.service';
import { SubcategoryResults } from 'src/models/interfaces';
import { ResultService } from 'src/services/results.service';
import { QuestionnaireService } from 'src/services/questionnaire.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
	selector: 'app-results',
	templateUrl: './results.component.html',
	styleUrls: ['./results.component.scss']
})

export class ResultsComponent implements OnInit {
	public userData;
	public docData;
	public reportByCategory: SubcategoryResults[][] = [];
	public isLoading: boolean = true;
	public userCatalogs = CatalogsUserForm;
	public reportTexts = ReportTexts;
	public questionnaire;
	public skipCatA = false;

	constructor(
		private route: ActivatedRoute,
		private dbSrv: DatabaseService,
		private router: Router,
		private rsltSrv: ResultService,
		private qstSrv: QuestionnaireService,
		public dialog: MatDialog
	) {
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			if (params.data === undefined || params.data === '') {
				this.router.navigate(['/user']);
			} else {
				this.dbSrv.get({collection: 'results', id: atob(params.data), data: {}}).then(doc => {
					this.docData = doc.data();
					this.docData.categories.forEach((category) => {
						this.reportByCategory.push(this.rsltSrv._generateReport(category));
					});
					this.dbSrv.get({
						collection: 'registeredUsers',
						id: this.docData.userId,
						data: {}
					}).then(userData => {
						this.userData = userData.data();
						this.skipCatA = this.userData.company.businessActivity == BusinessActivities.services;
						this.questionnaire = this.qstSrv.getQuestionnaire(this.skipCatA);
						this.isLoading = false;
						const dialogRef = this.dialog.open(DownloadDialog, {
							disableClose: true,
							data: {
								isLoading: false,
								message: 'Descarga aquí tu reporte en formato PDF',
								success: 'Descargar'
							}
						});
						dialogRef.afterClosed().subscribe((res) => {
							this.downloadReport();
						});
					});
				});
			}
		});
	}

	downloadReport() {
		const imgWidth = 297;
		const imgHeight = 210;
		const dialogRef = this.dialog.open(DownloadDialog, {
			disableClose: true,
			data: {
				isLoading: true
			}
		});
		const data = document.getElementById('cover');
		html2canvas(data ,{
			scale: .8,
		}).then(canvas => {

			const contentDataURL = canvas.toDataURL('image/png', 0.5);
			let pdf = new jspdf('l', 'mm', 'A4'); // A4 size page of PDF
			var position = 0;
			pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);

			const breakdown = document.getElementById('breakdown');
			html2canvas(breakdown,{
				scale: .8,
			}).then(canvasBreakdown => {
				const contentDataURLBreakdown= canvasBreakdown.toDataURL('image/png', 0.5);
				pdf.addPage('l', 'mm', 'a4');
				pdf.addImage(contentDataURLBreakdown, 'PNG', 0, position, imgWidth, imgHeight);
				const dataOpt0 = document.getElementById('opportunity0');
				html2canvas(dataOpt0,{
					scale: .8,
				}).then(canvasOpt0 => {
					const contentDataURLOpt0 = canvasOpt0.toDataURL('image/png', 0.5);
					pdf.addPage('l', 'mm', 'a4');
					pdf.addImage(contentDataURLOpt0, 'PNG', 0, position, imgWidth, imgHeight);
					const dataOpt1 = document.getElementById('opportunity1');
					html2canvas(dataOpt1,{
						scale: .8,
					}).then(canvasOpt1 => {
						const contentDataURLOpt1 = canvasOpt1.toDataURL('image/png', 0.5);
						pdf.addPage('l', 'mm', 'a4');
						pdf.addImage(contentDataURLOpt1, 'PNG', 0, position, imgWidth, imgHeight);
						if (this.skipCatA) {
							return;
						} else {
							const dataOpt2 = document.getElementById('opportunity2');
							return html2canvas(dataOpt2,{
								scale: .8,
							}).then(canvasOpt2 => {
								const contentDataURLOpt2 = canvasOpt2.toDataURL('image/png', 0.5);
								pdf.addPage('l', 'mm', 'a4');
								pdf.addImage(contentDataURLOpt2, 'PNG', 0, position, imgWidth, imgHeight);
								return;
							});
						}
					}).finally(() => {
						pdf.save('Reporte Herramienta de autoevaluación Economía Circular .pdf');
						dialogRef.close();
						this.finishDownload();
					});
				});
			});
		});
	}

	finishDownload() {
		const dialogRef = this.dialog.open(DownloadDialog, {
			disableClose: true,
			data: {
				isLoading: false,
				message: 'Se ha descargado exitosamente',
				success: 'OK'
			}
		});
		dialogRef.afterClosed().subscribe((res) => {
			this.router.navigate(['/']);
		});
	}


}

@Component({
	selector: 'dialog-download-dialog',
	templateUrl: './dialog-download-dialog.html',
})
export class DownloadDialog {
	constructor(
		public dialogRef: MatDialogRef<DownloadDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
	}
}
